module.exports = __webpack_public_path__ + "img/user.99ecc80b.png";